import './ResumeSection.scss';

export interface ExperienceItem {
  company: string;
  title: string;
  location?: string;
  startDate: string;
  endDate: string;
  bullets: string[];
}

export interface SkillGroup {
  label: string;
  items: string[];
}

export interface EducationItem {
  school: string;
  degree: string;
  startDate: string;
  endDate: string;
}

export type ResumeSectionData =
  | { title: 'Summary'; content: string }
  | { title: 'Experience'; items: ExperienceItem[] }
  | { title: 'Skills'; groups: SkillGroup[] }
  | { title: 'Education'; items: EducationItem[] };

interface ResumeSectionProps {
  section: ResumeSectionData;
}

const ResumeSection = ({ section }: ResumeSectionProps) => {
  switch (section.title) {
    case 'Summary':
      return (
        <div className="resume-section">
          <h2 className="section-title">{section.title}</h2>
          <p className="summary-content">{section.content}</p>
        </div>
      );

    case 'Experience':
      return (
        <div className="resume-section">
          <h2 className="section-title">{section.title}</h2>
          {section.items.map((item, i) => (
            <div key={i} className="experience-item">
              <div className="job-header">
                <div className="job-meta">
                  <span className="job-title">{item.title}</span>
                  <span className="company">
                    {item.company}{item.location ? ` · ${item.location}` : ''}
                  </span>
                </div>
                <span className="dates">{item.startDate} – {item.endDate}</span>
              </div>
              <ul className="bullets">
                {item.bullets.map((bullet, j) => (
                  <li key={j}>{bullet}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      );

    case 'Skills':
      return (
        <div className="resume-section">
          <h2 className="section-title">{section.title}</h2>
          <div className="skill-groups">
            {section.groups.map((group, i) => (
              <div key={i} className="skill-group">
                <span className="skill-group-label">{group.label}</span>
                <div className="skill-pills">
                  {group.items.map((skill, j) => (
                    <span key={j} className="skill-pill">{skill}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      );

    case 'Education':
      return (
        <div className="resume-section">
          <h2 className="section-title">{section.title}</h2>
          {section.items.map((item, i) => (
            <div key={i} className="education-item">
              <div className="job-header">
                <div className="job-meta">
                  <span className="job-title">{item.school}</span>
                  <span className="company">{item.degree}</span>
                </div>
                <span className="dates">{item.startDate} – {item.endDate}</span>
              </div>
            </div>
          ))}
        </div>
      );

    default:
      return null;
  }
};

export default ResumeSection;
